export const SPLIT_PAY_BANNER_MAIN_ID = "split-pay-banner-main";
